import React from "react";
import styles from "./style.module.css";

import { LineInput } from "components/Inputs/LineInput";
import { Button } from "aible";

export class AddUser extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: ""
    };
  }

  handleInvite(tenantID, email) {
    const { sendInviteFromTenant, setShowAddUser } = this.props;

    sendInviteFromTenant(tenantID, email);
    setShowAddUser(false);
    this.setState({ email: "" });
  }

  render() {
    const { hidden, setShowAddUser, activeTenant } = this.props;

    const { email } = this.state;

    const addUserClass = styles.addUser + " " + (hidden ? styles.hide : "");
    return (
      <div className={addUserClass}>
        <div className={styles.iLabel}>{"User E-mail Address:"}</div>
        <LineInput
          isBox
          ref="email"
          value={email}
          className={styles.input}
          updateInstant
          onChange={(val) => this.setState({ email: val })}
        />
        <div className={styles.fRight}>
          <Button type="secondary" style={{ marginRight: "10px" }} onClick={() => setShowAddUser(false)}>
            {"Cancel"}
          </Button>
          <Button type="primary" disabled={email === ""} onClick={() => this.handleInvite(activeTenant.id, email)}>
            {"Send Invite"}
          </Button>
        </div>
      </div>
    );
  }
}

export default AddUser;
